import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "row",
  style: {"border-bottom":"1px solid #D8D8D8"}
}
const _hoisted_2 = { class: "col-lg-9 col-md-12 col-12" }
const _hoisted_3 = { class: "col-lg-3 col-md-12 col-12" }
const _hoisted_4 = { class: "row mt-3" }
const _hoisted_5 = { class: "col-lg-9 col-md-12 col-sm-12" }
const _hoisted_6 = { class: "col-lg-3 col-md-12 col-12" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "col-lg-9 col-md-12 col-sm-12" }
const _hoisted_9 = { class: "col-lg-3 col-md-12 col-12" }
const _hoisted_10 = {
  key: 1,
  class: "row"
}
const _hoisted_11 = { class: "col-lg-9 col-md-12 col-sm-12" }
const _hoisted_12 = { class: "col-lg-3 col-md-12 col-12" }
const _hoisted_13 = { class: "d-flex justify-content-center w-100 mt-3" }

import {ErrorToast, SuccessToast} from '@/components/VueToast';
import {computed, nextTick, onMounted, PropType, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import coursePriceCoachingService from "@/api/Course/SocioTherapyCoaching";
import Datepicker from "@/components/picker/Datepicker.vue";
import BaseNumber from "@/components/base/BaseNumber.vue";
import useVuelidate from "@vuelidate/core";
import SelectVue from "@/components/SelectVue.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import {IFormRules, IPrice} from "@/interfaces/Course/SocioTherapy/ICoursePrice";
import {requiredRule} from "@/shared/validators/validationRules";
import SaveButton from "@/components/button/SaveButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubstituteTypePriceForm',
  props: {
  priceId: {
    type: Number as PropType<number | null>,
    required: false,
    default: null
  },
  meetingTypeDropdown: {
    type: Array,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
},
  emits: ['update:modelValue', 'update:submitForm'],
  setup(__props, { emit: __emit }) {

const {t} = useI18n();
const isLoaded = ref(false);
const isSubmitting = ref(false);
const emit = __emit;
const showHalfPriceDescription = ref(false)
const showTenMinutesPriceDescription = ref(false)

const props = __props;

const formData = ref<IPrice>({
  operationType: 'sociotherapie',
  priceType: '',
  startFrom: '',
  price: "",
  halfPrice: "",
  tenMinutesPrice: "",
  priceDescription: '',
  halfPriceDescription: '',
  tenMinutesPriceDescription: '',
});

const formRules = ref<IFormRules>({
  operationType: requiredRule(t),
  priceType: requiredRule(t),
  priceDescription: requiredRule(t),
  startFrom: requiredRule(t),
  price: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.price = formData.value.price ? Number(formData.value.price) : null;
    formData.value.halfPrice = formData.value.halfPrice ? Number(formData.value.halfPrice) : null;
    formData.value.tenMinutesPrice = formData.value.tenMinutesPrice ? Number(formData.value.tenMinutesPrice) : null;

    if (props.priceId) {
      await coursePriceCoachingService.putPrice(formData.value, +props.priceId);
    } else {
      await coursePriceCoachingService.postPrice(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getPriceData(priceId: number) {
  try {
    const {data} = await coursePriceCoachingService.getPrice(+priceId);
    const priceData = data.data;

    formData.value = {
      operationType: priceData.operationType,
      priceType: priceData.priceType,
      startFrom: priceData.startFrom,
      price: priceData.price,
      halfPrice: priceData.halfPrice,
      tenMinutesPrice: priceData.tenMinutesPrice,
      priceDescription: priceData.priceDescription,
      halfPriceDescription: priceData.halfPriceDescription,
      tenMinutesPriceDescription: priceData.tenMinutesPriceDescription
    };

    onUpdateMeetingType(data.data.priceType, true)
  } catch (error) {
    await ErrorToast(error);
  }
}

function onUpdateMeetingType(value: string, onFormUpdate: boolean = false) {
  if (!onFormUpdate) {
    formData.value.price = '';
    formData.value.halfPrice = '';
    formData.value.tenMinutesPrice = ''
  }

  if (value == "sociotherapy" || value == "initial_consultation") {
    formRules.value = {
      ...formRules.value,
      halfPriceDescription: requiredRule(t),
      tenMinutesPriceDescription: requiredRule(t),
    };

    showHalfPriceDescription.value = true
    showTenMinutesPriceDescription.value = true
  } else {
    formRules.value = {
      ...formRules.value,
      halfPriceDescription: "",
      tenMinutesPriceDescription: ""
    };

    showHalfPriceDescription.value = false
    showTenMinutesPriceDescription.value = false
  }
}

function onUpdatePrice() {
  nextTick(() => {
    formData.value.halfPrice = Math.round((Number(formData.value.price!) / 2) * 100) / 100;
    formData.value.tenMinutesPrice = Math.round((Number(formData.value.price!) / 60 * 10) * 100) / 100;
  });
}


onMounted(async () => {
  if (props.priceId) {
    await getPriceData(props.priceId);
  }

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (isLoaded.value)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        onSubmit: _withModifiers(submitForm, ["prevent"]),
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(SelectVue, {
              modelValue: formData.value.priceType,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((formData.value.priceType) = $event)),
                onUpdateMeetingType
              ],
              options: props.meetingTypeDropdown,
              required: true,
              label: "Preisart",
              validation: _unref(v$).priceType,
              messages: _unref(v$).priceType.required.$message
            }, null, 8, ["modelValue", "options", "validation", "messages"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Datepicker, {
              modelValue: formData.value.startFrom,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.startFrom) = $event)),
              required: true,
              label: _ctx.$t('general.start_from'),
              position: "down",
              validation: _unref(v$).startFrom,
              messages: _unref(v$).startFrom.required.$message
            }, null, 8, ["modelValue", "label", "validation", "messages"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(BaseInput, {
              modelValue: formData.value.priceDescription,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.priceDescription) = $event)),
              label: "Bezeichnung",
              required: true,
              validation: _unref(v$).priceDescription,
              messages: _unref(v$).priceDescription.required.$message
            }, null, 8, ["modelValue", "validation", "messages"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(BaseNumber, {
              "onUpdate:modelValue": [
                onUpdatePrice,
                _cache[3] || (_cache[3] = ($event: any) => ((formData.value.price) = $event))
              ],
              modelValue: formData.value.price,
              label: _ctx.$t('general.price'),
              required: true,
              min: -1000000,
              decimalPlaces: 2,
              validation: _unref(v$).price,
              messages: _unref(v$).price.required.$message
            }, null, 8, ["modelValue", "label", "validation", "messages"])
          ])
        ]),
        (showHalfPriceDescription.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(BaseInput, {
                  modelValue: formData.value.halfPriceDescription,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.halfPriceDescription) = $event)),
                  label: "Beschreibung der halben Einheit",
                  required: true,
                  validation: _unref(v$)?.halfUnitDescription,
                  messages: _unref(v$)?.halfUnitDescription?.required.$message
                }, null, 8, ["modelValue", "validation", "messages"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(BaseNumber, {
                  disabled: "disabled",
                  modelValue: formData.value.halfPrice,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.halfPrice) = $event)),
                  label: "halber Preis",
                  required: true,
                  min: -1000000,
                  decimalPlaces: 2
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        (showTenMinutesPriceDescription.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(BaseInput, {
                  modelValue: formData.value.tenMinutesPriceDescription,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.tenMinutesPriceDescription) = $event)),
                  label: "Zehn Minuten Beschreibung",
                  required: true,
                  validation: _unref(v$)?.tenMinutesPriceDescription,
                  messages: _unref(v$)?.tenMinutesPriceDescription?.required.$message
                }, null, 8, ["modelValue", "validation", "messages"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(BaseNumber, {
                  disabled: "disabled",
                  modelValue: formData.value.tenMinutesPrice,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.tenMinutesPrice) = $event)),
                  label: "Zehn-Minuten-Preis",
                  required: true,
                  min: -1000000,
                  decimalPlaces: 2
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(SaveButton, {
            label: _ctx.$t('general.button.save'),
            loading: isSubmitting.value
          }, null, 8, ["label", "loading"])
        ])
      ], 32))
    : _createCommentVNode("", true)
}
}

})